module.exports = function getResource(label) {
    const resources = {
        free: 'Gratuit'
    };

    return resources[label];
};
